import { Action, initialState, State } from 'store/store';

export const setTheme = (
  state: State = initialState,
  { data }: Action
): State => {
  //
  console.log(data);

  const nextState = {
    ...state,
    themeId: data.id,
    theme: { ...(state as any).theme, ...data.data },
  };

  return nextState;
};
